import Vue from "vue";
import { errorServeiceHandler, makeQueryFormDataDyn } from "../../helper";

const actions = {
  actPostResetPassword: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      console.log("payload", payload);
      let data = makeQueryFormDataDyn(payload);
      
      fetch(
        context.getters.baseUrl + "/subscriber/v1/subscriber/passwordreset",
        {
          method: "POST",
          body: data
        }
      )
        .then(errorServeiceHandler)
        .then(response => {
          return response.json()
        })
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        });
    });
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/forgotPassword.js